/* eslint-disable */

// Umbrella JS  http://umbrellajs.com/
// -----------
// Small, lightweight jQuery alternative
// @author Francisco Presencia Fandos https://francisco.io/
// @inspiration http://youmightnotneedjquery.com/

// Initialize the library
var query = function(parameter, context) {
    // Make it an instance of query() to avoid needing 'new' as in 'new query()' and just
    // use 'query().bla();'.
    // @reference http://stackoverflow.com/q/24019863
    // @reference http://stackoverflow.com/q/8875878
    if (!(this instanceof query)) {
        return new query(parameter, context);
    }

    // No need to further processing it if it's already an instance
    if (parameter instanceof query) {
        return parameter;
    }

    // Parse it as a CSS selector if it's a string
    if (typeof parameter === 'string') {
        parameter = this._select(parameter, context);
    }

    // If we're referring a specific node as in on('click', function(){ query(this) })
    // or the select() function returned a single node such as in '#id'
    if (parameter && parameter.nodeName) {
        parameter = [parameter];
    }

    // Convert to an array, since there are many 'array-like' stuff in js-land
    this.nodes = this._slice(parameter);
};

// Map query(...).length to query(...).nodes.length
query.prototype = {
    get length() {
        return this.nodes.length;
    }
};

// This made the code faster, read "Initializing instance variables" in
// https://developers.google.com/speed/articles/optimizing-javascript
query.prototype.nodes = [];

/*
 * Force it to be an array AND also it clones them
 * // http://toddmotto.com/a-comprehensive-dive-into-nodelists-arrays-converting-nodelists-and-understanding-the-dom/
 * For internal use only
 */
query.prototype._slice = function(pseudo) {
    // Check that it's not a valid object
    if (
        !pseudo ||
        pseudo.length === 0 ||
        typeof pseudo === 'string' ||
        pseudo.toString() === '[object Function]'
    )
        return [];

    // Accept also a query() object (that has .nodes)
    return pseudo.length ? [].slice.call(pseudo.nodes || pseudo) : [pseudo];
};

/*
 * Select the adecuate part from the context
 * For internal use only
 */
query.prototype._select = function(parameter, context) {
    const r = (context || document).querySelectorAll(parameter);
    const length = r.length;
    return length === 1 ? r[0] : r;
};

// Take the arguments and a couple of callback to handle the getter/setter pairs
// such as: .css('a'), .css('a', 'b'), .css({ a: 'b' })
query.prototype._pairs = function(name, value, get, set) {
    // Convert it into a plain object if it is not
    if (typeof value !== 'undefined') {
        const nm = name;
        name = {};
        name[nm] = value;
    }

    if (typeof name === 'object') {
        // Set the value of each one, for each of the { prop: value } pairs
        return this.each(node => {
            for (const key in name) {
                set(node, key, name[key]);
            }
        });
    }

    // Return the style of the first one
    return this.length ? get(this.first(), name) : '';
};

// Merge all of the nodes that the callback return into a simple array
query.prototype._array = function(callback) {
    callback = callback;
    var self = this;
    return this.nodes.reduce(function(list, node, i) {
        var val;
        if (callback) {
            val = callback.call(self, node, i);
            if (!val) val = false;
            if (typeof val === 'string') val = query(val);
            if (val instanceof query) val = val.nodes;
        } else {
            val = node.innerHTML;
        }
        return list.concat(val !== false ? val : []);
    }, []);
};

// Removed duplicated nodes, used for some specific methods
query.prototype._unique = function() {
    return query(
        this.nodes.reduce(function(clean, node) {
            var istruthy =
                node !== null && node !== undefined && node !== false;
            return istruthy && clean.indexOf(node) === -1
                ? clean.concat(node)
                : clean;
        }, [])
    );
};

// Merge all of the nodes that the callback returns
query.prototype._map = function(callback) {
    return callback ? query(this._array(callback))._unique() : this;
};

/**
 * Get the HTML representation of all matching elements.
 */
query.prototype._as_string = function() {
    var html = '';
    this.each(node => {
        html += node.outerHTML;
    });
    return html;
};

// Find all the nodes children of the current ones matched by a selector
query.prototype.find = function(selector) {
    return this._map(function(node) {
        return query(selector || '*', node);
    });
};

/**
 * .filter(selector)
 * Delete all of the nodes that don't pass the selector
 */
query.prototype.filter = function(selector) {
    // The default function if it's a CSS selector
    // Cannot change name to 'selector' since it'd mess with it inside this fn
    var callback = function(node) {
        // Make it compatible with some other browsers
        node.matches =
            node.matches ||
            node.msMatchesSelector ||
            node.webkitMatchesSelector;

        // Check if it's the same element (or any element if no selector was passed)
        return node.matches(selector || '*');
    };

    // filter() receives a function as in .filter(e => query(e).children().length)
    if (typeof selector === 'function') callback = selector;

    // filter() receives an instance of Umbrella as in .filter(query('a'))
    if (selector instanceof query) {
        callback = function(node) {
            return selector.nodes.indexOf(node) !== -1;
        };
    }

    // Just a native filtering function for ultra-speed
    return query(this.nodes.filter(callback));
};

// Travel the matched elements one node up
query.prototype.parent = function(selector) {
    return this._map(function(node) {
        return node.parentNode;
    }).filter(selector);
};

/**
 * Return first node
 */
query.prototype.first = function() {
    return this.nodes[0] || false;
};

/**
 * Return first node
 */
query.prototype.last = function() {
    return this.nodes[nodes.length - 1] || false;
};

/**
 * Find all the nodes children of the current ones matched by a selector
 */
query.prototype.find = function(selector) {
    return this._map(function(node) {
        return query(selector || '*', node);
    });
};

/**
 * Find the first ancestor that matches the selector for each node
 */
query.prototype.closest = function(selector) {
    return this._map(function(node) {
        // Keep going up and up on the tree. First element is also checked
        do {
            if (query(node).is(selector)) {
                return node;
            }
        } while ((node = node.parentNode) && node !== document);
    });
};

/**
 * Iterate through the node list.
 * @param {callback} callback The function that is called for each node
 */
query.prototype.each = function(callback) {
    if (this.length === 0)
        return this;

    // By doing callback.call we allow "this" to be the context for
    // the callback (see http://stackoverflow.com/q/4065353 precisely)
    this.nodes.forEach(callback.bind(this));

    return this;
};

/**
 * Same as each() but breaks when the callback returns false
 */
query.prototype.every = function(callback) {
    this.nodes.every(callback.bind(this));
    return this;
};

/**
 * Check if the nodes matches the selector.
 * @param {string} selector The selector to check.
 * @returns If at least one node does not match, it returns false.
 */
query.prototype.is = function(selector) {
    var result = true;
    this.every(node => {
        result = node.matches(selector);
        return result;
    });
    return result;
};

/**
 * Append HTML to all matching nodes. It does that by setting `element.innerHTML += html`.
 * @param {object} content The HTML as string or a query instance
 */
query.prototype.append = function(content) {
    var html = content instanceof query ? content._as_string() : content;
    return this.each(node => {
        node.innerHTML += html;
    });
};

// Merge all of the nodes that the callback return into a simple array
query.prototype.array = function(callback) {
    callback = callback;
    var self = this;
    return this.nodes.reduce(function(list, node, i) {
        var val;
        if (callback) {
            val = callback.call(self, node, i);
            if (!val) val = false;
            if (typeof val === 'string') val = query(val);
            if (val instanceof query) val = val.nodes;
        } else {
            val = node.innerHTML;
        }
        return list.concat(val !== false ? val : []);
    }, []);
};

// [INTERNAL USE ONLY]
// Removed duplicated nodes, used for some specific methods
query.prototype.unique = function() {
    return query(
        this.nodes.reduce(function(clean, node) {
            var istruthy =
                node !== null && node !== undefined && node !== false;
            return istruthy && clean.indexOf(node) === -1
                ? clean.concat(node)
                : clean;
        }, [])
    );
};

/**
 * Internal use only. This function checks to see if an element is in the page's body. As contains is inclusive and determining if the body contains itself isn't the intention of isInPage this case explicitly returns false.
https://developer.mozilla.org/en-US/docs/Web/API/Node/contains
 * @param  {[Object]}   node DOM node
 * @return {Boolean}    The Node.contains() method returns a Boolean value indicating whether a node is a descendant of a given node or not.
 */
query.prototype.isInPage = function isInPage(node) {
    return node === document.body ? false : document.body.contains(node);
};

// [INTERNAL USE ONLY]
// Add text in the specified position. It is used by other functions
query.prototype.adjacent = function(html, data, callback) {
    if (typeof data === 'number') {
        if (data === 0) {
            data = [];
        } else {
            data = new Array(data)
                .join()
                .split(',')
                .map(Number.call, Number);
        }
    }

    // Loop through all the nodes. It cannot reuse the eacharg() since the data
    // we want to do it once even if there's no "data" and we accept a selector
    return this.each(function(node, j) {
        var fragment = document.createDocumentFragment();

        // Allow for data to be falsy and still loop once
        query(data || {})
            .map(function(el, i) {
                // Allow for callbacks that accept some data
                var part =
                    typeof html === 'function'
                        ? html.call(this, el, i, node, j)
                        : html;

                if (typeof part === 'string') {
                    return this.generate(part);
                }

                return query(part);
            })
            .each(function(n) {
                this.isInPage(n)
                    ? fragment.appendChild(
                          query(n)
                              .clone()
                              .first()
                      )
                    : fragment.appendChild(n);
            });

        callback.call(this, node, fragment);
    });
};

// Merge all of the nodes that the callback returns
query.prototype.map = function(callback) {
    return callback ? query(this.array(callback)).unique() : this;
};

// Add some html as a sibling after each of the matched elements.
query.prototype.after = function(html, data) {
    return this.adjacent(html, data, function(node, fragment) {
        node.parentNode.insertBefore(fragment, node.nextSibling);
    });
};

/**
 * Prepend HTML to all matching nodes. It does that by setting `element.innerHTML = html + element.innerHTML`.
 * @param {object} content The HTML as string or a query instance
 */
query.prototype.prepend = function(content) {
    var html = content instanceof query ? content._as_string() : content;
    return this.each(node => {
        node.innerHTML = html + node.innerHTML;
    });
};

/**
 * Remove all matching nodes from the DOM
 */
query.prototype.remove = function() {
    // Loop through all the nodes
    return this.each(function(node) {
        // Perform the removal only if the node has a parent
        if (node.parentNode) node.parentNode.removeChild(node);
    });
};

/**
 * Add a class to each node
 *
 * @param {string} value The class to add
 */
query.prototype.addClass = function(value) {
    return this.each(node => {
        node.classList.add(value);
    });
};

/**
 * Remove a class from each node
 *
 * @param {string} value The class to remove
 */
query.prototype.removeClass = function(value) {
    return this.each(node => {
        node.classList.remove(value);
    });
};

/**
 * Toggle a class
 *
 * @param {string} value The class to toggle
 */
query.prototype.toggleClass = function(value) {
    return this.each(node => {
        node.classList.toggle(value);
    });
};

/**
 * Scolls to the first element.
 * 
 * @param options Options that can be passed to the `scrollIntoView()` function, see
 * https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView.
 */
query.prototype.scrollTo = function(options) {
    const f = this.first();
    if (f)
        f.scrollIntoView(options);
}

query.prototype.slideDown = function(duration) {
    return this.each(node => {
        node.style.removeProperty('display');
        let display = window.getComputedStyle(node).display;

        if (display === 'none') display = 'block';

        node.style.display = display;
        let height = node.offsetHeight;
        node.style.overflow = 'hidden';
        node.style.height = 0;
        node.style.paddingTop = 0;
        node.style.paddingBottom = 0;
        node.style.marginTop = 0;
        node.style.marginBottom = 0;
        node.offsetHeight;
        node.style.boxSizing = 'border-box';
        node.style.transitionProperty = 'height, margin, padding';
        node.style.transitionDuration = duration + 'ms';
        node.style.transitionTimingFunction = 'ease-in-out';
        node.style.height = height + 'px';
        node.style.removeProperty('padding-top');
        node.style.removeProperty('padding-bottom');
        node.style.removeProperty('margin-top');
        node.style.removeProperty('margin-bottom');
        window.setTimeout(() => {
            node.style.removeProperty('height');
            node.style.removeProperty('overflow');
            node.style.removeProperty('transition-duration');
            node.style.removeProperty('transition-property');
        }, duration);
    });
};

query.prototype.slideUp = function(duration) {
    return this.each(node => {
        node.style.transitionProperty = 'height, margin, padding';
        node.style.transitionDuration = duration + 'ms';
        node.style.transitionTimingFunction = 'ease-in-out';
        node.style.boxSizing = 'border-box';
        node.style.height = node.offsetHeight + 'px';
        node.offsetHeight;
        node.style.overflow = 'hidden';
        node.style.height = 0;
        node.style.paddingTop = 0;
        node.style.paddingBottom = 0;
        node.style.marginTop = 0;
        node.style.marginBottom = 0;
        window.setTimeout(() => {
            node.style.display = 'none';
            node.style.removeProperty('height');
            node.style.removeProperty('padding-top');
            node.style.removeProperty('padding-bottom');
            node.style.removeProperty('margin-top');
            node.style.removeProperty('margin-bottom');
            node.style.removeProperty('overflow');
            node.style.removeProperty('transition-duration');
            node.style.removeProperty('transition-property');
        }, duration);
    });
};

query.prototype.slideToggle = function(duration) {
    return this.each(node => {
        if (window.getComputedStyle(node).display === 'none') {
            return query(node).slideDown(duration);
        } else {
            return query(node).slideUp(duration);
        }
    });
};

/**
 * Check if any of the nodes have a class
 * @param {string} value The class to test
 * @return {boolean} Returns true if at least one ode has the class
 */
query.prototype.hasClass = function(value) {
    var result = false;
    this.every(node => {
        result = node.classList.contains(value);
        return !result;
    });
    return result;
};

/**
 * Subscribe to an event
 *
 * @param {string} event The name of the event, e.g. "click"
 * @param {callback} callback The callback to be called in the event
 * @example
 * query("#mybutton").on("click", function(e) { e.preventDefault(); alert("Nice try"); });
 */
query.prototype.on = function(event, callback) {
    return this.each(node => {
        node.addEventListener(event, callback);
        // The callback is needed for .off()
        node._e = node._e || {};
        node._e[event] = node._e[event] || [];
        node._e[event].push(callback);
    });
};

/**
 * Subscribe to a click event
 *
 * @param {callback} callback The callback to be called in the event
 * @example
 * query("#mybutton").on("click", function(e) { e.preventDefault(); alert("Nice try"); });
 */
query.prototype.click = function(callback) {
    return this.each(node => {
        node.addEventListener('click', callback);
        // The callback is needed for .off()
        node._e = node._e || {};
        node._e[event] = node._e[event] || [];
        node._e[event].push(callback);
    });
};

query.prototype.innerHeight = function() {
    return parseInt(window.getComputedStyle(this.first()).height); 
};

/**
 * Unsubscribe from an event
 *
 * @param {string} event The name of the event, e.g. "click"
 * @example
 * query("#mybutton").off("click");
 */
query.prototype.off = function(event) {
    return this.each(node => {
        query(node._e ? node._e[event] : []).each(callback => {
            node.removeEventListener(event, callback);
        });
    });
};

/**
 * Manually triggering an event
 *
 * @param {string} event The name of the event, e.g. "click"
 * @example
 * query("#mybutton").trigger("click");
 */
query.prototype.trigger = function(event) {
    return this.each(node => {
        const _event = new Event(event);
        node.dispatchEvent(_event);
    });
};

/**
 * Show all nodes. If previously hide() or toggle() was called with true as argument
 * (i.e. display: none was also added), it restores the old value it had before
 * hide() or toggle() was called.
 */
query.prototype.show = function() {
    return this.each(node => {
        node.style.visibility = 'visible';
        if (node.style.display === 'none') {
            if (typeof node._display !== 'undefined')
                node.style.display = node._display;
            else node.style.display = 'block';
        }
    });
};

/**
 * Hide all nodes. It does so by setting visibility: hidden so it
 * still occupies space.
 *
 * @param {boolean} b If true it also adds display: none. Default true
 * @example
 * // Add visibility: hidden and display: none to all .widget-zone elements
 * query(".widget-zone").hide();
 * // Add only visibility: hidden to all .widget-zone elements
 * query(".widget-zone").hide(false);
 */
query.prototype.hide = function(b = true) {
    return this.each(node => {
        node.style.visibility = 'hidden';
        if (b) {
            if (node.style.display !== 'none')
                node._display = node.style.display;
            node.style.display = 'none';
        }
    });
};

/**
 * Return if any of the nodes is visible, i.e. display != none
 */
query.prototype.visible = function() {
    var result = false;
    this.every(node => {
        result = node.style.display !== 'none';
        return !result;
    });
    return result;
};

/**
 * Return if any of the nodes is hidden, i.e. display == none
 */
query.prototype.hidden = function() {
    var result = false;
    this.every(node => {
        result = node.style.display === 'none';
        return !result;
    });
    return result;
};

/**
 * Toggle visibility of all nodes
 *
 * @param {boolean} b If true it also adds display: none. Default true
 */
query.prototype.toggle = function(b = true) {
    return this.each(node => {
        if (node.style.visibility === 'hidden') query(node).show();
        else query(node).hide(b);
    });
};

query.prototype.setVisible = function(b = true) {
    if (b) this.show(true);
    else this.hide(true);
};

/**
 * Get or set an attribute of all matching elements.
 * @param {string} name The name of the attribute
 * @param {string} value The value
 */
query.prototype.attr = function(name, value) {
    // This will handle those elements that can accept a pair with these footprints:
    // .attr('a'), .attr('a', 'b'), .attr({ a: 'b' })
    return this._pairs(
        name,
        value,
        (node, name) => node.getAttribute(name),
        (node, name, value) => {
            node.setAttribute(name, value);
        }
    );
};

/**
 * Remove an attribute from all matching elements
 * @param {string} name The name
 */
query.prototype.removeAttr = function(name) {
    return this.each(node => {
        node.removeAttribute(name);
    });
};

/**
 * Get the inline style of the first element, or set the inline style of all matching elements.
 * Note: This is only for inline styles.
 * @param {string} name The name of the style
 * @param {string} value The value of the style
 * @example
 * $("body").css("color", "red");
 * // Should print red
 * console.log($("body").css("color"));
 */
query.prototype.css = function(name, value) {
    if (value === undefined) return this.first().style[name];

    return this.each(node => {
        node.style[name] = value;
    });
};

/**
 * Get or set an data attribute of all matching elements.
 * @param {string} name The name of the attribute, will become data-name
 * @param {string} value The value
 */
query.prototype.data = function(name, value) {
    return this.attr(`data-${name}`, value);
};

/**
 * Gets or set the Text content
 */
query.prototype.text = function(value) {
    // Needs to check undefined as it might be ""
    if (value === undefined) {
        return this.first().textContent || '';
    }

    // If we're attempting to set some text
    // Loop through all the nodes
    return this.each(function(node) {
        // Set the text content to the node
        node.textContent = value;
    });
};

/**
 * Gets the HTML content of the first element, or sets the HTML content of all elements.
 */
query.prototype.html = function(value) {
    // Needs to check undefined as it might be ""
    if (value === undefined) {
        return this.first().innerHTML || '';
    }

    // If we're attempting to set some text
    // Loop through all the nodes
    return this.each(function(node) {
        // Set the text content to the node
        node.innerHTML = value;
    });
};

/**
 * Get the value of the first element, or sets the value of all matching elements.
 * @param {string} value The value
 */
query.prototype.val = function(value) {
    // Needs to check undefined as it might be ""
    if (value === undefined) {
        return this.first().value || '';
    }

    // If we're attempting to set some text
    // Loop through all the nodes
    return this.each(function(node) {
        // Set the text content to the node
        node.value = value;
    });
};

/**
 * Exchange 2 elements in the DOM tree
 * @param  {[type]} f First element
 * @param  {[type]} s Second element
 *
 * @example
 * $.swap($("#element2"), $("#element1"));
 */
query.swap = function(f, s) {
    var a = f.first();
    var b = s.first();
    var t = a.parentNode.insertBefore(document.createTextNode(''), a);
    b.parentNode.insertBefore(a, b); 
    t.parentNode.insertBefore(b, t); 
    t.parentNode.removeChild(t);
}

/**
 * Perform an asynchronous HTTP (Ajax) request.
 *
 * @param {object} settings A set of key/value pairs that configure the Ajax request. All settings except `url` are optional.
 * Following keys are supported:
 * * `type` HTTP method, GET or POST, default GET
 * * `url` The URL
 * * `data` string to be sent to the server
 * * `success` Callback function in case of success, i.e. HTTP status code == 200
 * * `error` Callback functiuon in case of an error
 * * `complete` Callback function called when request finished
 *
 * @example
 * $.ajax({
 *   type: "GET",
 *   url: 'someurl.html',
 *   success: function(responseText, status, xmlhttp) {
 *       $("#ajax-result").text("Success:" + responseText);
 *   },
 *   error: function(xmlhttp, status, responseText) {
 *       $("#ajax-result").text("Error:" + responseText);
 *   }
 * });
 */
query.ajax = function(settings) {
    if (!window.XMLHttpRequest)
        // Unsupported Browser
        return;
    var method = settings['type'] || 'GET';
    var url = settings['url'];
    var data = settings['data'] || '';

    var xmlhttp = new XMLHttpRequest();
    xmlhttp.onreadystatechange = function() {
        if (xmlhttp.readyState === 4) {
            if (xmlhttp.status === 200) {
                if (typeof settings['success'] === 'function')
                    settings['success'](
                        xmlhttp.responseText,
                        xmlhttp.status,
                        xmlhttp
                    );
            } else {
                if (typeof settings['error'] === 'function')
                    settings['error'](
                        xmlhttp,
                        xmlhttp.status,
                        xmlhttp.responseText
                    );
            }
            if (typeof settings['complete'] === 'function')
                settings['complete'](
                    xmlhttp.responseText,
                    xmlhttp,
                    xmlhttp.status
                );
        }
    };
    xmlhttp.onerror = function() {
        if (typeof settings['error'] === 'function')
            settings['error'](xmlhttp, xmlhttp.status, xmlhttp.responseText);
    };
    xmlhttp.onloadstart = function() {
        // Trigger something like jQuery(document).ajaxStart
        query(document).trigger('ajaxStart');
    };
    xmlhttp.addEventListener('loadend', function() {
        // Trigger something like jQuery(document).ajaxStop
        query(document).trigger('ajaxStop');
    });

    xmlhttp.open(method, url, true);
    xmlhttp.send(data);
};

/**
 * Load data from the server and place the returned HTML into the matching elements.
 * @param {string} url The URL
 * @param {any} data Data to be sent
 * @param {Function(String responseText, int status, XMLHttpRequest request)} complete Callback function when the request completed
 * @example
 * $(document).ready(() =>{
 *   $("#load-url-button").on("click", function(e) {
 *     e.preventDefault();
 *     $("#html-load-container").load($("#url-to-load-textbox").val());
 *   });
 * });
 */
query.prototype.load = function(url, data, complete) {
    if (!window.XMLHttpRequest)
        // Unsupported Browser
        return;
    var self = this;
    query.ajax({
        type: 'GET',
        url: url,
        data: data,
        complete: function(responseText, status, xmlhttp) {
            if (typeof complete === 'function')
                complete(responseText, status, xmlhttp);
            if (xmlhttp.status === 200)
                self.html(responseText);
        }
    });
};

/**
 * Provides a query(document).ready(...) convenience function but also for compatibility with jQuery.
 * It is fired when DOMContentLoaded is fired.
 *
 * @param {callback} callback The function that is called when the document is ready.
 * @example
 * query(document).ready(function() {
 *   console.log("Document is ready!");
 * });
 */
query.prototype.ready = function(callback) {
    return this.each(node => {
        node.addEventListener('DOMContentLoaded', () => {
            setTimeout(callback, 1);
        });
        // The callback is needed for .off()
        node._e = node._e || {};
        node._e[event] = node._e[event] || [];
        node._e[event].push(callback);
    });
};

// Delete all of the nodes that equals the filter
query.prototype.not = function (filter) {
    return this.filter(function (node) {
      return !u(node).is(filter || true);
    });
};

query.prototype.getHexBackgroundColor = function () {
    return (function (rgb) {
        return '#' + (!rgb ? 'FFFFFF' : rgb2hex(rgb));
    })(window.getComputedStyle(this.nodes[0]).getPropertyValue('background-color'));
};

query.prototype.getRGBABackgroundColor = function (opacity = 1) {
    const currentColor = window.getComputedStyle(this.nodes[0]).getPropertyValue('background-color');
    let r, g, b, currentAlpha;

    if (currentColor.startsWith('rgb(')) {
        const matches = currentColor.match(/rgb\((\d+), (\d+), (\d+)\)/);
        if (matches) {
            [, r, g, b] = matches.map(Number);
            currentAlpha = 1; // Default alpha for rgb()
        }
    } else if (currentColor.startsWith('rgba(')) {
        const matches = currentColor.match(/rgba\((\d+), (\d+), (\d+), ([\d.]+)\)/);
        if (matches) {
            [, r, g, b, currentAlpha] = matches.map(Number);
        }
    } else if (currentColor.startsWith('#')) {
        // Convert hex to rgb/rgba if needed for consistency
        const hex = currentColor.slice(1);
        if (hex.length === 3) {
            r = parseInt(hex[0] + hex[0], 16);
            g = parseInt(hex[1] + hex[1], 16);
            b = parseInt(hex[2] + hex[2], 16);
        } else if (hex.length === 6) {
            r = parseInt(hex.slice(0, 2), 16);
            g = parseInt(hex.slice(2, 4), 16);
            b = parseInt(hex.slice(4, 6), 16);
        } else if (hex.length === 8) {
            r = parseInt(hex.slice(0, 2), 16);
            g = parseInt(hex.slice(2, 4), 16);
            b = parseInt(hex.slice(4, 6), 16);
            currentAlpha = parseInt(hex.slice(6, 8), 16) / 255;
        }
        currentAlpha = currentAlpha === undefined ? 1 : currentAlpha;
    } else if (currentColor === 'transparent') {
        r = 0; g = 0; b = 0; currentAlpha = 0;
    } else {
        // For named colors or other unhandled cases, try to get computed style again, or return a default
        // For simplicity, we'll return black with the given opacity for unhandled cases.
        // A more robust solution might involve a temporary element to resolve the color.
        return `rgba(0, 0, 0, ${opacity})`;
    }

    if (r === undefined || g === undefined || b === undefined) {
        // Fallback for unparsed or unsupported color values
        return `rgba(0, 0, 0, ${opacity})`;
    }

    // Ensure opacity is a number between 0 and 1
    const finalOpacity = Math.max(0, Math.min(1, Number(opacity)));

    return `rgba(${r}, ${g}, ${b}, ${finalOpacity})`;
};

function rgb2hex(rgb) {
    const color = rgb.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
    return (color && color.length === 4)
        ? (`0${parseInt(color[1], 10).toString(16)}`).slice(-2)
        + (`0${parseInt(color[2], 10).toString(16)}`).slice(-2)
        + (`0${parseInt(color[3], 10).toString(16)}`).slice(-2) : '';
}



/**
 * To get sometnig like $(document).ready(). For possible events this may trigger, see
 * https://developer.mozilla.org/en-US/docs/Web/API/Document/readyState
 *
 * @example
 * // Same as  $(document).ready(function() { ... }
 * query(document).on("complete", function() {
 *   console.log(document.readyState == "complete");
 * }
 */
query(document).on('readystatechange', () => {
    query(document).trigger(document.readyState);
});


const $ = query;
export default $;

if (typeof module === 'object' && module.exports) {
    // Avoid breaking it for `import { u } from ...`. Add `import u from ...`
    module.exports = $;
    module.exports = query;
    module.exports.$ = query;
    module.exports.query = query;
    //module.exports.default = $;
}
